import { gql } from "@apollo/client"
import { COACH_TOOLS_API } from "../apolloClient"
import { resolveAcceptableProgressStanding } from "./resolveAcceptableProgressStanding"

export const ACCEPTABLE_PROGRESS_STANDING_QUERY = gql`
  query AcceptableProgressStanding {
    me {
      termination {
        status
        terminateCd
      }
      pgmProgressStatus {
        currentLevelKey
        mostRecentCompletedLevelKey
        levels {
          key
          status
          requirements {
            key
            status
          }
        }
      }
    }
  }
`

const DENIED_STANDING = {
  allowNextLevelPurchase: false,
  showReapplyPathOffer: false,
  showProgressStandingNotice: false,
}

/**
 * Map Coach Tools `me` (+ optional pgmProgress) to Acceptable Progress standing.
 * Missing `me` denies next-level purchase.
 */
export function standingFromMe(me, pgmProgress) {
  if (!me) {
    return DENIED_STANDING
  }

  return resolveAcceptableProgressStanding({
    me,
    pgmProgress: pgmProgress ?? me.pgmProgressStatus ?? me.pgmProgress,
  })
}

export async function fetchAllowNextLevelPurchase({ client }) {
  try {
    const { data } = await client.query({
      query: ACCEPTABLE_PROGRESS_STANDING_QUERY,
      context: { api: COACH_TOOLS_API },
    })

    return standingFromMe(data?.me).allowNextLevelPurchase
  } catch {
    return false
  }
}
